import getToken from "../../utils/getToken"
import { API } from "../../config/api"

export default async (id,data) => {
    try{
        const token = getToken()

        const response = await fetch(`${API}/reviews/${id}`,{
            method:'PUT',
            headers:{
                'Authorization': `Bearer ${token}`
            },
            body:data
        })

        const {success,review} = await response.json()

        return {success,review}
    }catch(error){
        console.log(error)

        return {success:false}
    }
}